const errorTypes = {
    TOKEN_EXPIRED: 'TokenExpired',
};

export default errorTypes;